import base from './base';

export default {
  sendCode(phone) {
    return base.post(`register/send_code`, {
      phone,
    });
  },
}
